import { render, staticRenderFns } from "./DataTableFilters.vue?vue&type=template&id=4f8173a4&"
import script from "./DataTableFilters.vue?vue&type=script&lang=js&"
export * from "./DataTableFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports